<template>
  <div class="honor">
    <basepanel>
      <div class="outer-box">
        <!-- horizontal-box 手机端加上该样式 -->
        <div :class="{'inner-box':true, 'horizontal-box':phoneshow}">
          <el-tabs
            v-model="activeIndex"
            @tab-click="handleClick"
            class="horizontal-tabs"
          >
            <el-tab-pane label="企业资质" name="1"></el-tab-pane>
            <el-tab-pane label="企业荣誉" name="2"></el-tab-pane>
          </el-tabs>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical"
            @select="handleSelect"
          >
            <el-menu-item index="1">
              <span
                :class="{ side: true, 'side-active': activeIndex == 1 }"
              ></span>
              <span slot="title">企业资质</span>
            </el-menu-item>
            <el-menu-item index="2">
              <span
                :class="{ side: true, 'side-active': activeIndex == 2 }"
              ></span>
              <span slot="title">企业荣誉</span>
            </el-menu-item>
          </el-menu>
          <div class="all-modules">
            <!-- 公司资质 -->
            <div v-if="activeIndex == 1" class="core">
              <div>
                <div
                  class="sec"
                  v-for="(val, index) in qualifications"
                  :key="index"
                  :class="{ special: phoneshow?((index + 1) % 2 == 0):((index + 1) % 3 == 0) }"
                >
                  <img class="top" :src="val.defineUrl" alt="" />
                  <p class="title">{{ val.title }}</p>
                </div>
              </div>
            </div>
            <!-- 公司荣誉 -->
            <div v-if="activeIndex == 2" class="core">
              <div>
                <div
                  class="sec"
                  v-for="(val, index) in honorLists"
                  :key="index"
                  :class="{ special: phoneshow?((index + 1) % 2 == 0):((index + 1) % 3 == 0) }"
                >
                  <img class="top" :src="val.defineUrl" alt="" />
                  <p class="title">{{ val.title }}</p>
                </div>
              </div>
            </div>
            <hr />
            <div class="bottom">
              <div class="right" @click="back">返回上一级</div>
            </div>
          </div>
        </div>
      </div>
    </basepanel>
  </div>
</template>

<script>
import basepanel from "../components/BasePanel";
import { listNextWithFilter } from "../api/index";
export default {
  name: "honor",
  components: { basepanel },
  data() {
    return {
      activeIndex: this.$route.query.type==1?"1":"2", //1公司资质，2公司荣誉
      // 核心技术
      honorLists: [],
      qualifications: [],
      screenWidth: document.body.clientWidth,
    };
  },
  computed:{
    phoneshow: function () {
      return this.screenWidth < 768 ? true : false;
    },
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    handleClick(tab) {
      this.activeIndex = (parseInt(tab.index) + 1).toString();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    async getHonorLists() {
      let send = {
        url: {
          page: 1,
          size: 50,
        },
        data: {
          categoryIdList: [this.$map.honorcategoryId],
          needData: true,
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let lists = res.data;
        lists.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });
        this.honorLists = lists;
      } else {
        console.log(res.msg);
      }
    },
    async getQualifications() {
      let send = {
        url: {
          page: 1,
          size: 30,
        },
        data: {
          categoryIdList: [this.$map.qualificationsId],
          needData: true,
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let lists = res.data;
        lists.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });
        this.qualifications = lists;
        // new WOW().init();
      } else {
        console.log(res.msg);
      }
    },
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.getHonorLists();
    this.getQualifications();
  },
};
</script>

<style scoped lang="less">
.honor {
  .right{
    text-align:right;
    cursor: pointer;
    line-height: 2em;
    font-size:1.375rem
  }
  .inner-box {
    display: flex;
    justify-content: space-between;
    .horizontal-tabs {
      display: none;
    }
    .all-modules {
      padding-left: 6%;
      .core {
        .sec {
          display: inline-block;
          vertical-align: middle;
          // cursor: pointer;
          margin-right: 2%;
          text-decoration: none;
          color: #000;
          margin-bottom: 20px;
          // background-color: #fff;
          // &:hover {
          //   box-shadow: 0 0 16px #0e6cb6;
          //   transition: all 0.3s ease;
          // }
          .top {
            width: 100%;
          }
          .title {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            text-align: center;
          }
        }
        .special {
          margin-right: 0;
        }
      }
    }

    // 左侧导航条
    .el-menu-vertical {
      .side {
        display: inline-block;
        // height: 33px;
        // width: 6px;
        // margin-right: 20px;
      }
      .side-active {
        background-color: #0e6cb6;
      }
    }
    .el-menu {
      background-color: transparent;
      border-right: none;
    }
    .el-menu-item {
      // font-size: 24px;
      // line-height: 33px;
      height: 0;
      padding-left: 0!important;
      // margin-bottom: 52px;
    }
    .el-menu-item.is-active {
      color: #0e6cb6;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      background-color: transparent;
    }
  }
  .horizontal-box {
    flex-direction: column;
    .horizontal-tabs {
      display: block;
      /deep/.el-tabs__header {
        margin-bottom: 20px;
        .el-tabs__nav {
        width: 100%;
        .el-tabs__item {
          width: 50%;
          text-align: center;
          padding: 0;
          color: #666666;
          &:hover {
            color: #0e6cb6;
          }
        }
        .el-tabs__item.is-active {
          color: #0e6cb6;
        }
        .el-tabs__active-bar {
          width: 17% !important;
          left: 16%;
          background-color: #0e6cb6;
        }
      }
      }
    }
    .el-menu-vertical {
      display: none;
    }
    .all-modules {
      padding-left: 0;
    }
  }
}
@media screen and (min-width: 1200px) {
  .el-menu-vertical {
    .side {
      height: 33px;
      width: 6px;
      margin-right: 20px;
    }
  }
  .el-menu-item {
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 52px;
  }
  .core {
    .sec {
      width: 32%;
    }
    .title {
      font-size: 22px;
      min-height: 100px;
      color: #333;
      line-height: 52px;
      letter-spacing: 3px;
    }
  }
  
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .el-menu-vertical {
    .side {
      height: 30px;
      width: 6px;
      margin-right: 20px;
    }
  }
  .el-menu-item {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 46px;
  }
  .core {
    .sec {
      width: 32%;
    }
    .title {
      font-size: 18px;
      min-height: 90px;
      color: #333;
      line-height: 46px;
      letter-spacing: 2px;
    }
  }
  
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  /deep/ .el-tabs__nav {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .el-menu-vertical {
    .side {
      height: 30px;
      width: 6px;
      margin-right: 16px;
    }
  }
  .el-menu-item {
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 46px;
  }
  .core {
    .sec {
      width: 48%;
    }
    .title {
      font-size: 16px;
      min-height: 56px;
      color: #333;
      line-height: 26px;
      letter-spacing: 2px;
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  /deep/ .el-tabs__nav {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-menu-vertical {
    width: 22%;
    .side {
      height: 18px;
      width: 4px;
      margin-right: 8px;
    }
  }
  .el-menu-item {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 30px;
  }
  .core {
    .sec {
      width: 48%;
    }
    .title {
      font-size: 12px;
      min-height: 40px;
      color: #333;
      line-height: 18px;
      letter-spacing: 2px;
    }
  }
}
</style>
